import { Box, Flex, Divider } from "@chakra-ui/layout";
import { Radio, RadioGroup } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { FormaDistribuicaoArrecadacaoEnum } from "features/arrecadacoes/enums";
import { useCurrentTenant } from "features/auth/tenant.store";
import colors from "resources/theme/colors";
import { BiBuildingHouse } from "react-icons/bi";
import { FiBarChart2 } from "react-icons/fi";
import { FaUsers } from "react-icons/fa";
import { IoBusinessOutline } from "react-icons/io5";
import IconShadowSelectableButton from "components/Button/IconShadowSelectableButton";
import Field from "components/Input/Field";
import SelectGrupoUnidade from "components/Input/SelectGrupoUnidade";
import SelectUnidade from "components/Input/SelectUnidade";
import { FormArrecadacaoChildrenFormProps } from "./FormArrecadacao";
import { TitleWrapper } from "./TitleWrapper";
import SelectTipoDestino from "ui/components/Input/SelectTipoDestino";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import RenderSelectEntidade from "components/SelectDestinos/RenderSelectEntidade";
import { Destino } from "features/arrecadacoes/typings/form";
import SelectMultipleOptionDisplay from "components/SelectMultipleOptionDisplay/index";
import { TipoConsumoEnum } from "core/features/consumo/typings";
// destinoId

function FormUnidades({
  control,
  watch,
  setValue,
  current,
}: FormArrecadacaoChildrenFormProps) {
  const { tenant } = useCurrentTenant();

  const form = watch();

  const formaDistribuicaoArrecadacaoId = form.formaDistribuicaoArrecadacaoId;
  const destinoId = form.destinoId;

  const isTodasUnidades =
    formaDistribuicaoArrecadacaoId ===
    FormaDistribuicaoArrecadacaoEnum.TodasUnidades;

  const isConsumo =
    formaDistribuicaoArrecadacaoId === FormaDistribuicaoArrecadacaoEnum.Consumo;

  const isGrupoUnidades =
    formaDistribuicaoArrecadacaoId ===
    FormaDistribuicaoArrecadacaoEnum.GrupoUnidades;

  const onPushDestino = (destino: Destino) => {
    const removerDestinos = form.removerDestinos;

    if (
      removerDestinos.findIndex((d) => d.destinoId === destino.destinoId) === -1
    ) {
      setValue("removerDestinos", [...removerDestinos, destino]);
    }
  };

  const onRemoveDestino = (id: string) => {
    const removerDestinos = form.removerDestinos;

    setValue(
      "removerDestinos",
      removerDestinos.filter((d) => d.destinoId !== id)
    );
  };

  const onRemoveAllDestinos = () => {
    setValue("removerDestinos", []);
  };

  const onRemoveGrupos = () => {
    const removerDestinos = form.removerDestinos;

    setValue(
      "removerDestinos",
      removerDestinos.filter(
        (d) => d.tipoDestinoId !== TipoDestinoEnum.UmGrupoUnidades
      )
    );
  };

  return (
    <Flex
      display={current ? undefined : "none"}
      flexDir="column"
      flex={1}
      w="100%"
    >
      <Box as={Row} mb={4}>
        <Col sm={24}>
          <TitleWrapper>De quem será cobrado?</TitleWrapper>

          <Field
            control={control}
            name="formaDistribuicaoArrecadacaoId"
            rules={{
              required: current,
            }}
            render={({ field }) => (
              <Flex flexDir="column">
                <Box as={Row} gutter={30} mb={8}>
                  <Box as={Col} sm={12}>
                    <IconShadowSelectableButton
                      value={FormaDistribuicaoArrecadacaoEnum.TodasUnidades}
                      selected={
                        field.value ===
                        FormaDistribuicaoArrecadacaoEnum.TodasUnidades
                      }
                      onChange={(v) => {
                        setValue("destinoId", undefined);
                        field.onChange(v);
                      }}
                      Icon={IoBusinessOutline}
                      color={colors.blue500}
                      text="Todas as unidades (recomendado)"
                      iconSize={24}
                      fontSize={13}
                    />
                  </Box>

                  <Box as={Col} sm={12}>
                    <IconShadowSelectableButton
                      value={FormaDistribuicaoArrecadacaoEnum.UnicaUnidade}
                      selected={
                        field.value ===
                        FormaDistribuicaoArrecadacaoEnum.UnicaUnidade
                      }
                      onChange={(v) => {
                        setValue("destinoId", undefined);
                        field.onChange(v);
                      }}
                      Icon={BiBuildingHouse}
                      color={colors.cyan}
                      text="Apenas uma unidade"
                      iconSize={24}
                      fontSize={13}
                    />
                  </Box>
                </Box>

                <Box as={Row} gutter={30}>
                  <Box as={Col} sm={12}>
                    <IconShadowSelectableButton
                      value={FormaDistribuicaoArrecadacaoEnum.GrupoUnidades}
                      selected={
                        field.value ===
                        FormaDistribuicaoArrecadacaoEnum.GrupoUnidades
                      }
                      onChange={(v) => {
                        setValue("destinoId", undefined);
                        onRemoveGrupos();
                        field.onChange(v);
                      }}
                      Icon={FaUsers}
                      color={colors.cyan}
                      text="Um grupo de unidades"
                      iconSize={24}
                      fontSize={13}
                    />
                  </Box>

                  <Box as={Col} sm={12}>
                    <IconShadowSelectableButton
                      value={FormaDistribuicaoArrecadacaoEnum.Consumo}
                      selected={
                        field.value === FormaDistribuicaoArrecadacaoEnum.Consumo
                      }
                      onChange={(v) => {
                        setValue("destinoId", undefined);
                        field.onChange(v);
                      }}
                      Icon={FiBarChart2}
                      color={colors.orange}
                      text="De quem consumiu gás, água, água mineral, esgoto ou energia"
                      iconSize={24}
                      fontSize={13}
                    />
                  </Box>
                </Box>
              </Flex>
            )}
          />
        </Col>
      </Box>
      {isGrupoUnidades ? (
        <>
          <TitleWrapper>Grupo de unidades a ser cobrado</TitleWrapper>
          <Box as={Row} mb={4}>
            <Col sm={12}>
              <Field
                shouldUnregister
                control={control}
                name="destinoId"
                rules={{
                  required: current,
                }}
                render={({ field, isInvalid }) => (
                  <SelectGrupoUnidade isInvalid={isInvalid} {...field} />
                )}
              />
            </Col>
          </Box>
        </>
      ) : null}
      {[
        FormaDistribuicaoArrecadacaoEnum.TodasUnidades,
        FormaDistribuicaoArrecadacaoEnum.GrupoUnidades,
        FormaDistribuicaoArrecadacaoEnum.Consumo,
      ].includes(
        formaDistribuicaoArrecadacaoId as FormaDistribuicaoArrecadacaoEnum
      ) ? (
        <>
          <TitleWrapper>
            {isTodasUnidades || isConsumo
              ? "Quer remover alguma unidade ou grupo de unidades?"
              : "Quer remover alguma unidade?"}
          </TitleWrapper>

          <Box as={Row} gutter={isTodasUnidades || isConsumo ? 30 : 0}>
            {isTodasUnidades || isConsumo ? (
              <Col sm={12}>
                <Field
                  name="removerTipoDestinoId"
                  control={control}
                  render={({ field, isInvalid }) => (
                    <SelectTipoDestino
                      onChange={(v) => {
                        field.onChange(v);
                      }}
                      value={field.value}
                      isInvalid={isInvalid}
                      showEmail={false}
                      showTodasUnidades={false}
                    />
                  )}
                />
              </Col>
            ) : null}

            <Col sm={12}>
              <Field
                shouldUnregister
                control={control}
                name="removerDestinoId"
                render={({ field, isInvalid }) => (
                  <RenderSelectEntidade
                    tenantId={tenant.id}
                    field={field}
                    isInvalid={isInvalid}
                    unidadeSelectGruposUnidadesIds={
                      isGrupoUnidades && destinoId ? [destinoId] : undefined
                    }
                    onChangeUnidade={(v, option) => {
                      onPushDestino({
                        tipoDestinoId: TipoDestinoEnum.UmaUnidade,
                        destinoId: v,
                        label: option.label,
                      });
                    }}
                    onChangeGrupo={(v, option) => {
                      onPushDestino({
                        tipoDestinoId: TipoDestinoEnum.UmGrupoUnidades,
                        destinoId: v,
                        label: option.label,
                      });
                    }}
                    tipoDestinoId={
                      isTodasUnidades || isConsumo
                        ? (form.removerTipoDestinoId as TipoDestinoEnum)
                        : TipoDestinoEnum.UmaUnidade
                    }
                    selectSize={"large"}
                    inputSize={"md"}
                  />
                )}
              />
            </Col>

            <Divider my={4} />
            <Box mx={2} w="100%">
              <Field
                name="removerDestinos"
                control={control}
                render={({ field }) =>
                  form?.removerDestinos?.length ? (
                    <Box w="100%">
                      <SelectMultipleOptionDisplay
                        borderBottom={false}
                        clearButton={true}
                        clearButtonPosition="top"
                        options={field.value.map((d: Destino) => ({
                          id: d.destinoId,
                          label: d.label,
                        }))}
                        onRemove={onRemoveDestino}
                        onRemoveAll={onRemoveAllDestinos}
                      />
                    </Box>
                  ) : (
                    <></>
                  )
                }
              />
            </Box>
          </Box>
        </>
      ) : null}

      {formaDistribuicaoArrecadacaoId ===
      FormaDistribuicaoArrecadacaoEnum.UnicaUnidade ? (
        <>
          <TitleWrapper>Unidade a ser cobrada</TitleWrapper>
          <Box as={Row} mb={4}>
            <Col sm={12}>
              <Field
                shouldUnregister
                control={control}
                name="destinoId"
                rules={{
                  required: current,
                }}
                render={({ field, isInvalid }) => (
                  <SelectUnidade
                    isInvalid={isInvalid}
                    value={field.value}
                    tenantId={tenant.id}
                    onChange={field.onChange}
                    getPopupContainer={(triggerNode: any) => {
                      return triggerNode.parentNode;
                    }}
                    style={{ width: "100%" }}
                  />
                )}
              />
            </Col>
          </Box>
        </>
      ) : null}

      {formaDistribuicaoArrecadacaoId ===
      FormaDistribuicaoArrecadacaoEnum.Consumo ? (
        <Box as={Row} mt={8}>
          <Col sm={24}>
            <TitleWrapper>Tipo do consumo*</TitleWrapper>
            <Field
              shouldUnregister
              control={control}
              name="tipoConsumoId"
              rules={{
                required: current,
              }}
              render={({ field }) => (
                <RadioGroup
                  w="fit-content"
                  display="flex"
                  flexDir="column"
                  value={field.value}
                  onChange={field.onChange}
                >
                  <Radio value={TipoConsumoEnum.Gas} mb={2}>
                    Gás
                  </Radio>
                  <Radio value={TipoConsumoEnum.Agua} mb={2}>
                    Água
                  </Radio>
                  <Radio value={TipoConsumoEnum.AguaMineral} mb={2}>
                    Água Mineral
                  </Radio>
                  <Radio value={TipoConsumoEnum.Esgoto} mb={2}>
                    Esgoto
                  </Radio>
                  <Radio value={TipoConsumoEnum.Energia}>Energia</Radio>
                </RadioGroup>
              )}
            />
          </Col>
        </Box>
      ) : null}
    </Flex>
  );
}

export default FormUnidades;
